import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Grid,
  Card,
  CardContent,
  Typography,
  Container,
  Box,
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Snackbar,
  Alert,
  Tabs,
  Tab,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  useTheme,
  Paper,
  Stack,
  InputAdornment,
  alpha,
  Fade,
  Zoom,
  Badge,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  InputBase,
  FormControl,
  InputLabel,
  Select,
  CardMedia,
  LinearProgress,
  Rating,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  useMediaQuery,
  CardActionArea,
  Collapse,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  AvatarGroup,
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Skeleton,
  SwipeableDrawer,
  BottomNavigation,
  BottomNavigationAction,
  Fab
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  AttachMoney as AttachMoneyIcon,
  MoreVert as MoreVertIcon,
  Search,
  Add as AddIcon,
  Check as CheckIcon,
  Business,
  Person,
  Percent,
  Image as ImageIcon,
  Close,
  Save,
  Cancel,
  Refresh,
  Download,
  Print,
  Share,
  TrendingUp,
  TrendingDown,
  AccountBalance,
  Receipt,
  Payment,
  Star,
  StarBorder,
  Warning,
  CheckCircle,
  Info,
  ShoppingCart,
  LocalShipping,
  Assessment,
  Timeline as TimelineIcon,
  Email,
  Phone,
  LocationOn,
  Analytics,
  FilterList,
  Clear,
  CalendarToday,
  ExpandMore,
  ChevronRight,
  Dashboard,
  TableChart,
  GridView,
  BarChart,
  PieChart,
  MonetizationOn,
  DateRange,
  Description,
  FileCopy,
  PictureAsPdf,
  Email as EmailIcon,
  WhatsApp,
  Facebook,
  Twitter,
  Link as LinkIcon,
  Settings,
  Help,
  Storefront,
  Assessment as AssessmentIcon,
  Menu as MenuIcon,
  Home,
  People,
  Timeline as TimelineIconAlt
} from "@mui/icons-material";
import { motion, AnimatePresence } from "framer-motion";
import { format, subDays, subMonths, isWithinInterval, startOfMonth, endOfMonth } from "date-fns";
import { fr } from "date-fns/locale";
import Partenaire from "../Services/Partenaire";
import ExcelTablePartenaire from "../Components/Tables/ExcelPartenaire";
import MontantDateStatueList from "../Components/MontantStauteComponent";

// ==================== ANIMATION VARIANTS ====================
const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 }
};

const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.08
    }
  }
};

const scaleIn = {
  initial: { scale: 0.9, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0.9, opacity: 0 }
};

const slideInLeft = {
  initial: { x: -50, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: 50, opacity: 0 }
};

// ==================== STYLED COMPONENTS ====================

const GradientCard = ({ children, color, onClick, sx = {} }) => {
  const [hovered, setHovered] = useState(false);
  
  return (
    <motion.div
      whileHover={{ y: -5 }}
      transition={{ duration: 0.2 }}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <Paper
        elevation={0}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={onClick}
        sx={{
          p: { xs: 2, sm: 3 },
          borderRadius: 4,
          background: `linear-gradient(135deg, ${color}10 0%, ${color}05 100%)`,
          border: `1px solid ${alpha(color, hovered ? 0.4 : 0.15)}`,
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          position: "relative",
          overflow: "hidden",
          ...sx,
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "4px",
            background: `linear-gradient(90deg, ${color}, ${alpha(color, 0.6)})`,
            transform: hovered ? "scaleX(1)" : "scaleX(0)",
            transition: "transform 0.4s ease",
            transformOrigin: "left"
          }
        }}
      >
        {children}
      </Paper>
    </motion.div>
  );
};

const AnimatedStatCard = ({ title, value, icon: Icon, color, trend, subtitle, onClick, loading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  if (loading) {
    return (
      <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 4 }}>
        <Skeleton variant="circular" width={isMobile ? 40 : 48} height={isMobile ? 40 : 48} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="60%" height={isMobile ? 24 : 32} />
        <Skeleton variant="text" width="40%" height={isMobile ? 16 : 20} />
      </Paper>
    );
  }
  
  return (
    <motion.div
      whileHover={{ y: -5, scale: isMobile ? 1 : 1.02 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <Paper
        elevation={0}
        onClick={onClick}
        sx={{
          p: { xs: 2, sm: 3 },
          borderRadius: 4,
          background: "white",
          border: `1px solid ${alpha(color, 0.2)}`,
          cursor: onClick ? "pointer" : "default",
          transition: "all 0.3s ease",
          position: "relative",
          overflow: "hidden",
          "&:hover": {
            boxShadow: isMobile ? `0 10px 20px ${alpha(color, 0.2)}` : `0 20px 40px ${alpha(color, 0.2)}`,
            borderColor: alpha(color, 0.4)
          }
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
          <Avatar sx={{ 
            bgcolor: alpha(color, 0.1), 
            color: color, 
            width: { xs: 48, sm: 56 }, 
            height: { xs: 48, sm: 56 },
            boxShadow: `0 8px 16px ${alpha(color, 0.2)}`
          }}>
            <Icon sx={{ fontSize: { xs: 24, sm: 28 } }} />
          </Avatar>
          {trend !== undefined && trend !== null && (
            <Chip
              size="small"
              icon={trend >= 0 ? <TrendingUp sx={{ fontSize: 14 }} /> : <TrendingDown sx={{ fontSize: 14 }} />}
              label={`${Math.abs(trend)}%`}
              sx={{
                bgcolor: alpha(trend >= 0 ? "#10b981" : "#ef4444", 0.1),
                color: trend >= 0 ? "#10b981" : "#ef4444",
                fontWeight: 700,
                fontSize: "0.7rem",
                height: 24
              }}
            />
          )}
        </Box>
        <Typography variant="h4" fontWeight={800} sx={{ color: "#1f2937", mb: 0.5, fontSize: { xs: '1.5rem', sm: '2rem' } }}>
          {value}
        </Typography>
        <Typography variant="body2" sx={{ color: "#6b7280", fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" sx={{ color: "#9ca3af", mt: 0.5, display: "block" }}>
            {subtitle}
          </Typography>
        )}
      </Paper>
    </motion.div>
  );
};

// LARGER PARTNER CARD COMPONENT with mobile optimization
const PartnerCard = ({ partenaire, onClick, onMenuOpen, hovered, setHovered, setTabValue }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <motion.div
      whileHover={{ y: isMobile ? -4 : -8, scale: isMobile ? 1 : 1.02 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      onMouseEnter={() => setHovered(partenaire.id)}
      onMouseLeave={() => setHovered(null)}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: 4,
          background: "white",
          border: `1px solid ${hovered === partenaire.id ? alpha("#667eea", 0.4) : "#E5E7EB"}`,
          transition: "all 0.3s ease",
          position: "relative",
          overflow: "hidden",
          cursor: "pointer",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "4px",
            background: `linear-gradient(90deg, #667eea, #764ba2)`,
            transform: hovered === partenaire.id ? "scaleX(1)" : "scaleX(0)",
            transition: "transform 0.3s ease",
            transformOrigin: "left"
          }
        }}
      >
        <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: { xs: 2, sm: 3 }, mb: { xs: 2, sm: 3 } }}>
            <Badge
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              badgeContent={
                <Box
                  sx={{
                    width: { xs: 10, sm: 14 },
                    height: { xs: 10, sm: 14 },
                    bgcolor: "#10b981",
                    borderRadius: "50%",
                    border: "2px solid white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                  }}
                />
              }
            >
              <Avatar
                src={partenaire.image}
                sx={{
                  width: { xs: 60, sm: 90 },
                  height: { xs: 60, sm: 90 },
                  bgcolor: alpha("#667eea", 0.1),
                  border: `3px solid ${hovered === partenaire.id ? "#667eea" : "transparent"}`,
                  transition: "all 0.3s ease",
                  boxShadow: hovered === partenaire.id ? "0 12px 24px rgba(102,126,234,0.3)" : "none"
                }}
              >
                {partenaire.name?.charAt(0).toUpperCase()}
              </Avatar>
            </Badge>

            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" fontWeight={800} sx={{ color: "#1f2937", mb: 1, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                    {partenaire.name}
                  </Typography>
                  <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
                    <Chip
                      label={`${partenaire.commission}% Commission`}
                      size="small"
                      icon={<Percent sx={{ fontSize: 12 }} />}
                      sx={{
                        bgcolor: alpha("#667eea", 0.1),
                        color: "#667eea",
                        fontWeight: 600,
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        height: { xs: 28, sm: 32 }
                      }}
                    />
                    <Chip
                      label="Actif"
                      size="small"
                      icon={<CheckCircle sx={{ fontSize: 12 }} />}
                      sx={{
                        bgcolor: alpha("#10b981", 0.1),
                        color: "#10b981",
                        fontWeight: 600,
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        height: { xs: 28, sm: 32 }
                      }}
                    />
                  </Box>
                </Box>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    onMenuOpen(e, partenaire.id);
                  }}
                  size="small"
                  sx={{
                    color: "#9ca3af",
                    "&:hover": { bgcolor: alpha("#667eea", 0.1), color: "#667eea" }
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
              </Box>
            </Box>
          </Box>

          <Divider sx={{ my: { xs: 1.5, sm: 2 } }} />

          <Button
            variant="contained"
            fullWidth
            startIcon={<VisibilityIcon />}
            onClick={(e) => {
              e.stopPropagation();
              onClick(partenaire.name, partenaire.id);
            }}
            size={isMobile ? "medium" : "large"}
            sx={{
              borderRadius: 2,
              background: 'linear-gradient(45deg, #667eea, #764ba2)',
              textTransform: "none",
              fontWeight: 600,
              py: { xs: 1, sm: 1.2 },
              fontSize: { xs: "0.8rem", sm: "0.9rem" },
              '&:hover': {
                transform: isMobile ? 'translateY(-1px)' : 'translateY(-2px)',
                boxShadow: '0 8px 16px rgba(102,126,234,0.3)'
              }
            }}
          >
            Voir les paiements
          </Button>
        </Box>
      </Paper>
    </motion.div>
  );
};

// ==================== MAIN COMPONENT ====================

const PartenairesPage = ({ sidebarOpen }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  
  // State Management
  const [partenaires, setPartenaires] = useState([]);
  const [selectedPartenaireId, setSelectedPartenaireId] = useState(null);
  const [selectedPartenaireName, setSelectedPartenaireName] = useState(null);
  const [encaissements, setEncaissements] = useState([]);
  const [newPartenaire, setNewPartenaire] = useState({ name: "", image: "", commission: "" });
  const [submitting, setSubmitting] = useState(false);
  const [editingPartenaire, setEditingPartenaire] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [partenaireToDelete, setPartenaireToDelete] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentPartnerId, setCurrentPartnerId] = useState(null);
  const [success, setSuccess] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewMode, setViewMode] = useState('grid');
  const [sortBy, setSortBy] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(isMobile ? 4 : 6);
  const [selectedPeriod, setSelectedPeriod] = useState('month');
  const [showFilters, setShowFilters] = useState(false);
  const [statsLoading, setStatsLoading] = useState(false);
  const [exportMenuAnchor, setExportMenuAnchor] = useState(null);
  const [speedDialOpen, setSpeedDialOpen] = useState(false);
  const [performanceData, setPerformanceData] = useState({});
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [bottomNavValue, setBottomNavValue] = useState(0);

  const restaurantId = localStorage.getItem("restaurantId");

  // Update rows per page based on screen size
  useEffect(() => {
    setRowsPerPage(isMobile ? 4 : isTablet ? 5 : 6);
  }, [isMobile, isTablet]);

  // Responsive padding based on sidebar and screen size
  const mainContentPadding = {
    pl: sidebarOpen ? (isMobile ? 1 : 32) : (isMobile ? 1 : 2),
    pr: isMobile ? 1 : 2,
    pt: isMobile ? 1 : 3,
    transition: theme.transitions.create(['padding'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    })
  };

  // Fetch data
  const fetchPartenaires = async () => {
    if (!restaurantId) return;
    
    try {
      setLoading(true);
      const fetchedPartenaires = await Partenaire.getAllPartenaires(restaurantId);
      const filteredPartenaires = fetchedPartenaires.filter(p => p.restaurantId === restaurantId);
      setPartenaires(filteredPartenaires);
      
      // Calculate performance metrics
      calculatePerformanceMetrics(filteredPartenaires);
    } catch (error) {
      setError("Échec du chargement des partenaires. Veuillez réessayer.");
      console.error("Error fetching partners:", error);
    } finally {
      setLoading(false);
    }
  };

  const calculatePerformanceMetrics = async (partners) => {
    setStatsLoading(true);
    try {
      const metrics = {};
      for (const partner of partners) {
        const encaissementsData = await Partenaire.getEncaissementsForPartenaire(partner.name, restaurantId);
        const totalAmount = encaissementsData.reduce((sum, e) => sum + (e.montant || 0), 0);
        const commissionAmount = totalAmount * (parseFloat(partner.commission) / 100);
        metrics[partner.id] = {
          totalSales: totalAmount,
          commissionAmount: commissionAmount,
          transactionCount: encaissementsData.length,
          lastTransaction: encaissementsData[0]?.date || null
        };
      }
      setPerformanceData(metrics);
    } catch (error) {
      console.error("Error calculating metrics:", error);
    } finally {
      setStatsLoading(false);
    }
  };

  useEffect(() => {
    if (restaurantId) {
      fetchPartenaires();
    }
  }, [restaurantId]);

  // Filtering and sorting
  const filteredPartenaires = partenaires
    .filter(p => {
      const matchesSearch = p.name.toLowerCase().includes(searchTerm.toLowerCase());
      return matchesSearch;
    })
    .sort((a, b) => {
      let aVal, bVal;
      if (sortBy === 'name') {
        aVal = a.name;
        bVal = b.name;
      } else if (sortBy === 'commission') {
        aVal = parseFloat(a.commission);
        bVal = parseFloat(b.commission);
      } else {
        aVal = a[sortBy];
        bVal = b[sortBy];
      }
      
      if (sortOrder === 'asc') {
        return aVal > bVal ? 1 : -1;
      } else {
        return aVal < bVal ? 1 : -1;
      }
    });

  const paginatedPartenaires = filteredPartenaires.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // Statistics
  const stats = {
    total: partenaires.length,
    avgCommission: partenaires.reduce((acc, p) => acc + (parseFloat(p.commission) || 0), 0) / (partenaires.length || 1),
    totalSales: Object.values(performanceData).reduce((sum, p) => sum + (p.totalSales || 0), 0),
    totalCommission: Object.values(performanceData).reduce((sum, p) => sum + (p.commissionAmount || 0), 0),
    activeCount: partenaires.filter(p => performanceData[p.id]?.lastTransaction && 
      isWithinInterval(new Date(performanceData[p.id].lastTransaction), {
        start: subMonths(new Date(), 3),
        end: new Date()
      })).length
  };

  // Handlers
  const handleAddPartenaire = async () => {
    if (!restaurantId || !newPartenaire.name || !newPartenaire.commission) {
      setError("Le nom et la commission sont des champs obligatoires");
      return;
    }

    const partnerExists = partenaires.some(
      p => p.name.toLowerCase() === newPartenaire.name.toLowerCase() && p.restaurantId === restaurantId
    );

    if (partnerExists) {
      setError("Ce partenaire existe déjà");
      return;
    }

    setSubmitting(true);
    try {
      const partenaire = new Partenaire(
        newPartenaire.name,
        newPartenaire.image,
        newPartenaire.commission,
        restaurantId
      );
      await partenaire.addPartenaire();
      await fetchPartenaires();
      setSuccess("Partenaire ajouté avec succès !");
      setNewPartenaire({ name: "", image: "", commission: "" });
      setOpenDialog(false);
    } catch (error) {
      setError("Échec de l'ajout du partenaire. Veuillez réessayer.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleSaveEditPartenaire = async () => {
    if (!restaurantId || !editingPartenaire?.id) {
      setError("Partenaire sélectionné invalide pour la mise à jour.");
      return;
    }

    try {
      await Partenaire.updatePartenaire(editingPartenaire.id, {
        name: newPartenaire.name,
        image: newPartenaire.image,
        commission: newPartenaire.commission,
        restaurantId: restaurantId,
      });
      await fetchPartenaires();
      setEditingPartenaire(null);
      setNewPartenaire({ name: "", image: "", commission: "" });
      setOpenDialog(false);
      setSuccess("Partenaire modifié avec succès !");
    } catch (error) {
      setError("Échec de la mise à jour du partenaire.");
    }
  };

  const handleDeleteConfirmation = (id) => {
    setPartenaireToDelete(id);
    setDeleteConfirmOpen(true);
  };

  const handleDeletePartenaire = async () => {
    try {
      await Partenaire.deletePartenaire(partenaireToDelete, restaurantId);
      setPartenaires(partenaires.filter(p => p.id !== partenaireToDelete));
      setDeleteConfirmOpen(false);
      setSuccess("Partenaire supprimé avec succès !");
      // Clear selected partner if it was deleted
      if (selectedPartenaireId === partenaireToDelete) {
        setSelectedPartenaireId(null);
        setSelectedPartenaireName(null);
      }
    } catch (error) {
      setError("Échec de la suppression du partenaire.");
    }
  };

  const handleViewEncaissements = async (name, id) => {
    try {
      const fetchedEncaissements = await Partenaire.getEncaissementsForPartenaire(name, restaurantId);
      setEncaissements(fetchedEncaissements);
      setSelectedPartenaireName(name);
      setSelectedPartenaireId(id);
      setTabValue(0);
      // On mobile, scroll to the details section
      if (isMobile) {
        setTimeout(() => {
          document.getElementById('partner-details')?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } catch (error) {
      setError("Échec du chargement des paiements.");
    }
  };

  const handleViewFinance = async (name, id) => {
    setSelectedPartenaireName(name);
    setSelectedPartenaireId(id);
    setTabValue(1);
    // On mobile, scroll to the details section
    if (isMobile) {
      setTimeout(() => {
        document.getElementById('partner-details')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  const exportData = (format) => {
    const data = filteredPartenaires.map(p => ({
      'Nom': p.name,
      'Commission (%)': p.commission,
      'Nombre de transactions': performanceData[p.id]?.transactionCount || 0,
      'Dernière transaction': performanceData[p.id]?.lastTransaction ? 
        format(new Date(performanceData[p.id].lastTransaction), 'dd/MM/yyyy') : 'Aucune'
    }));
    
    setSuccess(`Export ${format.toUpperCase()} initié avec succès`);
    setExportMenuAnchor(null);
  };

  const handleCloseError = () => setError(null);
  const handleCloseSuccess = () => setSuccess(null);

  // If no restaurant ID selected
  if (!restaurantId) {
    return (
      <Box sx={{ ...mainContentPadding, pt: 3, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Zoom in={true}>
          <Paper sx={{ p: { xs: 3, sm: 6 }, borderRadius: 4, textAlign: 'center', maxWidth: 500, mx: isMobile ? 2 : 0 }}>
            <Business sx={{ fontSize: { xs: 60, sm: 80 }, color: '#9AA6B2', mb: 2 }} />
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, fontSize: { xs: '1.25rem', sm: '2rem' } }}>
              Aucun restaurant sélectionné
            </Typography>
            <Typography variant="body2" sx={{ color: '#5F6B7A' }}>
              Veuillez sélectionner un restaurant pour gérer vos partenaires
            </Typography>
          </Paper>
        </Zoom>
      </Box>
    );
  }

  return (
    <Box sx={{ ...mainContentPadding, minHeight: '100vh', position: 'relative', overflowX: 'hidden', pb: isMobile ? 8 : 3 }}>
      {/* Background Pattern */}
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 20% 50%, rgba(102,126,234,0.03) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(118,75,162,0.03) 0%, transparent 50%)',
        pointerEvents: 'none',
        zIndex: 0
      }} />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1, px: { xs: 1, sm: 2 } }}>
        <motion.div
          initial="initial"
          animate="animate"
          variants={staggerContainer}
        >
          {/* Hero Section - Mobile Optimized */}
          <motion.div variants={fadeInUp}>
            <Paper
              elevation={0}
              sx={{
                mb: { xs: 2, sm: 4 },
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: { xs: 3, sm: 4 },
                overflow: 'hidden',
                position: 'relative'
              }}
            >
              <Box sx={{ 
                p: { xs: 2, sm: 3, md: 4 },
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: 2, sm: 0 }
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 2, sm: 3 }, width: '100%', justifyContent: { xs: 'flex-start', sm: 'flex-start' } }}>
                  <motion.div
                    whileHover={{ rotate: 360, scale: 1.1 }}
                    transition={{ duration: 0.5 }}
                  >
                    <Avatar
                      sx={{
                        width: { xs: 50, sm: 70, md: 80 },
                        height: { xs: 50, sm: 70, md: 80 },
                        background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                        boxShadow: '0 20px 30px rgba(255,215,0,0.3)'
                      }}
                    >
                      <Business sx={{ fontSize: { xs: 28, sm: 40, md: 48 }, color: '#1E2A3A' }} />
                    </Avatar>
                  </motion.div>
                  <Box>
                    <Typography 
                      variant="h4" 
                      sx={{ 
                        fontWeight: 800,
                        background: 'linear-gradient(45deg, #FFFFFF 30%, #FFD700 90%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        mb: 0.5,
                        fontSize: { xs: '1.2rem', sm: '1.8rem', md: '2.5rem' }
                      }}
                    >
                      Gestion des Partenaires
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)', fontWeight: 400, fontSize: { xs: '0.7rem', sm: '0.875rem' } }}>
                      {stats.total} partenaires • Commission moyenne: {stats.avgCommission.toFixed(1)}%
                    </Typography>
                  </Box>
                </Box>
                
                {!isMobile && (
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Tooltip title="Rafraîchir" arrow>
                      <IconButton 
                        onClick={fetchPartenaires}
                        sx={{ color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' } }}
                      >
                        <Refresh />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Exporter" arrow>
                      <IconButton 
                        onClick={(e) => setExportMenuAnchor(e.currentTarget)}
                        sx={{ color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' } }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Aide" arrow>
                      <IconButton sx={{ color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' } }}>
                        <Help />
                      </IconButton>
                    </Tooltip>
                  </Box>
                )}
              </Box>
            </Paper>
          </motion.div>

          {/* Stats Cards - Responsive Grid */}
          <Grid container spacing={{ xs: 1, sm: 2, md: 3 }} sx={{ mb: { xs: 2, sm: 4 } }}>
            <Grid item xs={6} sm={6} md={3}>
              <AnimatedStatCard
                title="Total Partenaires"
                value={stats.total}
                icon={Business}
                color="#667eea"
                trend={12}
                loading={loading}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <AnimatedStatCard
                title="Commission Moyenne"
                value={`${stats.avgCommission.toFixed(1)}%`}
                icon={Percent}
                color="#10b981"
                trend={-2}
                loading={loading}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <AnimatedStatCard
                title="Partenaires Actifs"
                value={stats.activeCount}
                icon={CheckCircle}
                color="#f59e0b"
                loading={loading}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <AnimatedStatCard
                title="Commission Totale"
                value={`${stats.totalCommission.toLocaleString()} TND`}
                icon={MonetizationOn}
                color="#ef4444"
                loading={loading}
              />
            </Grid>
          </Grid>

          {/* Search and Actions Bar - Mobile Optimized */}
          <motion.div variants={fadeInUp}>
            <Paper sx={{ 
              p: { xs: 1.5, sm: 2 }, 
              mb: { xs: 2, sm: 4 }, 
              borderRadius: { xs: 2, sm: 3 },
              background: '#FFFFFF',
              border: '1px solid #E5E7EB'
            }}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1.5, sm: 2 }} alignItems="center">
                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                  <Paper
                    component="form"
                    sx={{
                      p: '2px 4px',
                      display: 'flex',
                      alignItems: 'center',
                      flex: 1,
                      border: '1px solid #E5E7EB',
                      borderRadius: 2,
                      bgcolor: '#F9FAFB'
                    }}
                  >
                    <IconButton sx={{ p: '8px' }}>
                      <Search sx={{ color: '#9ca3af', fontSize: { xs: 18, sm: 20 } }} />
                    </IconButton>
                    <InputBase
                      sx={{ ml: 1, flex: 1, fontSize: { xs: '0.875rem', sm: '1rem' } }}
                      placeholder="Rechercher un partenaire..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    {searchTerm && (
                      <IconButton sx={{ p: '8px' }} onClick={() => setSearchTerm("")}>
                        <Close sx={{ fontSize: { xs: 14, sm: 18 } }} />
                      </IconButton>
                    )}
                  </Paper>
                  <Tooltip title="Filtres avancés">
                    <IconButton 
                      onClick={() => setShowFilters(!showFilters)}
                      sx={{ 
                        bgcolor: showFilters ? alpha('#667eea', 0.1) : 'transparent',
                        color: showFilters ? '#667eea' : '#6b7280'
                      }}
                    >
                      <FilterList fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                  </Tooltip>
                </Box>

                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', width: { xs: '100%', sm: 'auto' }, justifyContent: 'space-between' }}>
                  {!isMobile && (
                    <>
                      <Button
                        variant={viewMode === 'grid' ? 'contained' : 'outlined'}
                        onClick={() => setViewMode('grid')}
                        size="small"
                        sx={{ minWidth: 40, px: 1.5 }}
                      >
                        <GridView fontSize="small" />
                      </Button>
                      <Button
                        variant={viewMode === 'table' ? 'contained' : 'outlined'}
                        onClick={() => setViewMode('table')}
                        size="small"
                        sx={{ minWidth: 40, px: 1.5 }}
                      >
                        <TableChart fontSize="small" />
                      </Button>
                    </>
                  )}
                  
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => {
                      setEditingPartenaire(null);
                      setNewPartenaire({ name: "", image: "", commission: "" });
                      setOpenDialog(true);
                    }}
                    size={isMobile ? "small" : "medium"}
                    sx={{
                      background: 'linear-gradient(45deg, #667eea, #764ba2)',
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                      py: { xs: 0.75, sm: 1 },
                      '&:hover': {
                        transform: isMobile ? 'translateY(-1px)' : 'translateY(-2px)',
                        boxShadow: '0 10px 20px rgba(102,126,234,0.3)'
                      }
                    }}
                  >
                    {isMobile ? "Ajouter" : "Nouveau Partenaire"}
                  </Button>
                </Box>
              </Stack>

              {/* Advanced Filters */}
              <Collapse in={showFilters}>
                <Box sx={{ mt: { xs: 1.5, sm: 2 }, pt: { xs: 1.5, sm: 2 }, borderTop: '1px solid #E5E7EB' }}>
                  <Grid container spacing={{ xs: 1, sm: 2 }}>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Trier par</InputLabel>
                        <Select
                          value={sortBy}
                          onChange={(e) => setSortBy(e.target.value)}
                          label="Trier par"
                        >
                          <MenuItem value="name">Nom</MenuItem>
                          <MenuItem value="commission">Commission</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Ordre</InputLabel>
                        <Select
                          value={sortOrder}
                          onChange={(e) => setSortOrder(e.target.value)}
                          label="Ordre"
                        >
                          <MenuItem value="asc">Croissant</MenuItem>
                          <MenuItem value="desc">Décroissant</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>
              </Collapse>
            </Paper>
          </motion.div>

          {/* View Mode Toggle for Mobile */}
          {isMobile && (
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
              <Paper sx={{ p: 0.5, borderRadius: 3, display: 'inline-flex', gap: 0.5 }}>
                <Button
                  variant={viewMode === 'grid' ? 'contained' : 'text'}
                  onClick={() => setViewMode('grid')}
                  size="small"
                  sx={{ 
                    borderRadius: 2,
                    minWidth: 80,
                    fontSize: '0.75rem',
                    py: 0.5
                  }}
                >
                  <GridView fontSize="small" sx={{ mr: 0.5 }} /> Grille
                </Button>
                <Button
                  variant={viewMode === 'table' ? 'contained' : 'text'}
                  onClick={() => setViewMode('table')}
                  size="small"
                  sx={{ 
                    borderRadius: 2,
                    minWidth: 80,
                    fontSize: '0.75rem',
                    py: 0.5
                  }}
                >
                  <TableChart fontSize="small" sx={{ mr: 0.5 }} /> Tableau
                </Button>
              </Paper>
            </Box>
          )}

          {/* Partners Display */}
          {loading ? (
            <Box sx={{ width: '100%', py: { xs: 4, sm: 8 }, textAlign: 'center' }}>
              <CircularProgress size={isMobile ? 40 : 60} thickness={4} sx={{ mb: 2, color: '#667eea' }} />
              <Typography variant="body2" color="textSecondary">
                Chargement des partenaires...
              </Typography>
            </Box>
          ) : filteredPartenaires.length === 0 ? (
            <Fade in={true}>
              <Paper sx={{ 
                p: { xs: 4, sm: 8 }, 
                textAlign: 'center', 
                borderRadius: 4,
                background: '#FFFFFF'
              }}>
                <Business sx={{ fontSize: { xs: 60, sm: 80 }, color: '#9ca3af', mb: 2 }} />
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
                  Aucun partenaire trouvé
                </Typography>
                <Typography variant="body2" sx={{ color: '#6b7280', mb: 3 }}>
                  {searchTerm ? 'Essayez de modifier votre recherche' : 'Commencez par ajouter un partenaire'}
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setEditingPartenaire(null);
                    setNewPartenaire({ name: "", image: "", commission: "" });
                    setOpenDialog(true);
                  }}
                  sx={{
                    borderRadius: 2,
                    background: 'linear-gradient(45deg, #667eea, #764ba2)',
                    px: 4,
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }}
                >
                  Ajouter un partenaire
                </Button>
              </Paper>
            </Fade>
          ) : viewMode === 'grid' ? (
            <motion.div
              initial="initial"
              animate="animate"
              variants={staggerContainer}
            >
              <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
                <AnimatePresence>
                  {paginatedPartenaires.map((partenaire) => (
                    <Grid item xs={12} sm={6} md={6} lg={4} key={partenaire.id}>
                      <PartnerCard
                        partenaire={partenaire}
                        onClick={(name, id) => handleViewEncaissements(name, id)}
                        onMenuOpen={(e, id) => {
                          setAnchorEl(e.currentTarget);
                          setCurrentPartnerId(id);
                        }}
                        hovered={hoveredCard}
                        setHovered={setHoveredCard}
                        setTabValue={setTabValue}
                      />
                    </Grid>
                  ))}
                </AnimatePresence>
              </Grid>
            </motion.div>
          ) : (
            <Paper sx={{ borderRadius: { xs: 2, sm: 3 }, overflowX: 'auto' }}>
              <TableContainer component={Paper} sx={{ borderRadius: { xs: 2, sm: 3 }, overflowX: 'auto' }}>
                <Table size={isMobile ? "small" : "medium"}>
                  <TableHead sx={{ bgcolor: '#F9FAFB' }}>
                    <TableRow>
                      <TableCell sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>Partenaire</TableCell>
                      <TableCell align="right" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>Commission</TableCell>
                      <TableCell align="right" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>Transactions</TableCell>
                      <TableCell align="center" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>Statut</TableCell>
                      <TableCell align="center" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedPartenaires.map((partenaire) => (
                      <TableRow key={partenaire.id} hover>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
                            <Avatar src={partenaire.image} sx={{ width: { xs: 32, sm: 40 }, height: { xs: 32, sm: 40 } }}>
                              {partenaire.name?.charAt(0)}
                            </Avatar>
                            <Typography fontWeight={600} sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
                              {partenaire.name}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell align="right">
                          <Chip
                            label={`${partenaire.commission}%`}
                            size="small"
                            sx={{ bgcolor: alpha('#667eea', 0.1), color: '#667eea', fontSize: { xs: '0.7rem', sm: '0.75rem' } }}
                          />
                        </TableCell>
                        <TableCell align="right" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
                          {performanceData[partenaire.id]?.transactionCount || 0}
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label="Actif"
                            size="small"
                            icon={<CheckCircle sx={{ fontSize: 12 }} />}
                            sx={{ bgcolor: alpha('#10b981', 0.1), color: '#10b981', fontSize: { xs: '0.7rem', sm: '0.75rem' } }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            size="small"
                            onClick={() => handleViewEncaissements(partenaire.name, partenaire.id)}
                            sx={{ p: { xs: 0.5, sm: 1 } }}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => handleViewFinance(partenaire.name, partenaire.id)}
                            sx={{ p: { xs: 0.5, sm: 1 } }}
                          >
                            <AttachMoneyIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              setAnchorEl(e.currentTarget);
                              setCurrentPartnerId(partenaire.id);
                            }}
                            sx={{ p: { xs: 0.5, sm: 1 } }}
                          >
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )}

          {/* Pagination - Responsive */}
          {filteredPartenaires.length > 0 && (
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
              <TablePagination
                component="div"
                count={filteredPartenaires.length}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                rowsPerPageOptions={isMobile ? [4, 8, 12] : [6, 12, 18, 24]}
                labelRowsPerPage={isMobile ? "Lignes" : "Lignes par page"}
                labelDisplayedRows={({ from, to, count }) => 
                  isMobile ? `${from}-${to}` : `${from}-${to} sur ${count}`
                }
                sx={{
                  '& .MuiTablePagination-toolbar': {
                    flexWrap: 'wrap',
                    minHeight: { xs: 'auto', sm: 52 },
                    px: { xs: 1, sm: 2 }
                  },
                  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                  }
                }}
              />
            </Box>
          )}

          {/* Partner Details Section with ID for mobile scrolling */}
          {selectedPartenaireId && (
            <motion.div
              id="partner-details"
              variants={slideInLeft}
              initial="initial"
              animate="animate"
            >
              <Paper sx={{ 
                mt: 4, 
                borderRadius: { xs: 3, sm: 4 },
                background: '#FFFFFF',
                border: '1px solid #E5E7EB',
                overflow: 'hidden'
              }}>
                <Box sx={{ 
                  p: { xs: 1.5, sm: 3 }, 
                  background: 'linear-gradient(135deg, #F9FAFB 0%, #FFFFFF 100%)',
                  borderBottom: '1px solid #E5E7EB',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: { xs: 1, sm: 0 }
                }}>
                  <Tabs 
                    value={tabValue} 
                    onChange={(e, newValue) => setTabValue(newValue)}
                    variant={isMobile ? "fullWidth" : "standard"}
                    sx={{
                      width: { xs: '100%', sm: 'auto' },
                      '& .MuiTab-root': {
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: { xs: '0.7rem', sm: '0.9rem' },
                        minHeight: { xs: 40, sm: 48 },
                        px: { xs: 1, sm: 2 }
                      },
                      '& .Mui-selected': {
                        color: '#667eea'
                      },
                      '& .MuiTabs-indicator': {
                        backgroundColor: '#667eea',
                        height: 3
                      }
                    }}
                  >
                    <Tab icon={<Receipt />} iconPosition={isMobile ? "top" : "start"} label={isMobile ? "Paiements" : "Historique des Paiements"} />
                    <Tab icon={<TrendingUp />} iconPosition={isMobile ? "top" : "start"} label={isMobile ? "Analyse" : "Analyse Financière"} />
                  </Tabs>
                  <IconButton onClick={() => {
                    setSelectedPartenaireId(null);
                    setSelectedPartenaireName(null);
                  }} size={isMobile ? "small" : "medium"}>
                    <Close />
                  </IconButton>
                </Box>

                <Box sx={{ p: { xs: 2, sm: 3 } }}>
                  {tabValue === 0 && (
                    <ExcelTablePartenaire
                      partenairesData={partenaires.filter(p => p.restaurantId === restaurantId)}
                      encaissement={encaissements}
                      selectedPartenaire={selectedPartenaireName}
                    />
                  )}

                  {tabValue === 1 && (
                    <MontantDateStatueList 
                      partenaireId={selectedPartenaireId}
                      restaurantId={restaurantId}
                    />
                  )}
                </Box>
              </Paper>
            </motion.div>
          )}

          {/* Footer - Responsive */}
          {!isMobile && (
            <motion.div variants={fadeInUp}>
              <Box sx={{ 
                mt: 4, 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                p: 2,
                bgcolor: '#FFFFFF',
                borderRadius: 3,
                border: '1px solid #E5E7EB',
                flexWrap: 'wrap',
                gap: 2
              }}>
                <Typography variant="caption" sx={{ color: '#9ca3af' }}>
                  Dernière mise à jour: {new Date().toLocaleDateString('fr-FR')} à {new Date().toLocaleTimeString('fr-FR')}
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Chip
                    size="small"
                    icon={<Business />}
                    label={`${partenaires.length} partenaires`}
                    sx={{ bgcolor: '#F9FAFB', color: '#4b5563' }}
                  />
                  <Chip
                    size="small"
                    icon={<Percent />}
                    label={`Commission moy. ${stats.avgCommission.toFixed(1)}%`}
                    sx={{ bgcolor: '#F9FAFB', color: '#4b5563' }}
                  />
                </Box>
              </Box>
            </motion.div>
          )}
        </motion.div>
      </Container>

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <Paper
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            borderRadius: 0,
            borderTop: '1px solid #E5E7EB',
            bgcolor: '#FFFFFF'
          }}
          elevation={3}
        >
          <BottomNavigation
            value={bottomNavValue}
            onChange={(event, newValue) => {
              setBottomNavValue(newValue);
              if (newValue === 0) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              } else if (newValue === 1) {
                fetchPartenaires();
              } else if (newValue === 2) {
                setMobileDrawerOpen(true);
              }
            }}
            sx={{
              height: 56,
              '& .MuiBottomNavigationAction-root': {
                color: '#9ca3af',
                '&.Mui-selected': {
                  color: '#667eea'
                }
              }
            }}
          >
            <BottomNavigationAction label="Accueil" icon={<Home />} />
            <BottomNavigationAction label="Rafraîchir" icon={<Refresh />} />
            <BottomNavigationAction label="Menu" icon={<MenuIcon />} />
          </BottomNavigation>
        </Paper>
      )}

      {/* Mobile Drawer Menu */}
      <SwipeableDrawer
        anchor="bottom"
        open={mobileDrawerOpen}
        onClose={() => setMobileDrawerOpen(false)}
        onOpen={() => setMobileDrawerOpen(true)}
        swipeAreaWidth={56}
        sx={{
          '& .MuiDrawer-paper': {
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            maxHeight: '70vh'
          }
        }}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" fontWeight={700}>Actions rapides</Typography>
            <IconButton onClick={() => setMobileDrawerOpen(false)} size="small">
              <Close />
            </IconButton>
          </Box>
          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() => {
                  setEditingPartenaire(null);
                  setNewPartenaire({ name: "", image: "", commission: "" });
                  setOpenDialog(true);
                  setMobileDrawerOpen(false);
                }}
                sx={{ mb: 1 }}
              >
                Nouveau partenaire
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<Download />}
                onClick={(e) => {
                  setExportMenuAnchor(e.currentTarget);
                  setMobileDrawerOpen(false);
                }}
                sx={{ mb: 1 }}
              >
                Exporter
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<Help />}
                sx={{ mb: 1 }}
              >
                Aide
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<Settings />}
                sx={{ mb: 1 }}
              >
                Paramètres
              </Button>
            </Grid>
          </Grid>
        </Box>
      </SwipeableDrawer>

      {/* Export Menu */}
      <Menu
        anchorEl={exportMenuAnchor}
        open={Boolean(exportMenuAnchor)}
        onClose={() => setExportMenuAnchor(null)}
        TransitionComponent={Fade}
        PaperProps={{
          sx: {
            maxHeight: '80vh',
            width: isMobile ? '90vw' : 'auto'
          }
        }}
      >
        <MenuItem onClick={() => exportData('excel')}>
          <ListItemIcon><Description fontSize="small" /></ListItemIcon>
          <ListItemText primary="Export Excel" />
        </MenuItem>
        <MenuItem onClick={() => exportData('pdf')}>
          <ListItemIcon><PictureAsPdf fontSize="small" /></ListItemIcon>
          <ListItemText primary="Export PDF" />
        </MenuItem>
        <MenuItem onClick={() => exportData('csv')}>
          <ListItemIcon><FileCopy fontSize="small" /></ListItemIcon>
          <ListItemText primary="Export CSV" />
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => exportData('email')}>
          <ListItemIcon><EmailIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Envoyer par email" />
        </MenuItem>
      </Menu>

      {/* Mobile Speed Dial - Hidden on mobile since we have bottom nav */}
      {!isMobile && (
        <SpeedDial
          ariaLabel="Actions rapides"
          sx={{ position: 'fixed', bottom: 16, right: 16 }}
          icon={<SpeedDialIcon />}
          onClose={() => setSpeedDialOpen(false)}
          onOpen={() => setSpeedDialOpen(true)}
          open={speedDialOpen}
        >
          <SpeedDialAction
            icon={<AddIcon />}
            tooltipTitle="Nouveau partenaire"
            onClick={() => {
              setEditingPartenaire(null);
              setNewPartenaire({ name: "", image: "", commission: "" });
              setOpenDialog(true);
              setSpeedDialOpen(false);
            }}
          />
          <SpeedDialAction
            icon={<Refresh />}
            tooltipTitle="Rafraîchir"
            onClick={() => {
              fetchPartenaires();
              setSpeedDialOpen(false);
            }}
          />
          <SpeedDialAction
            icon={<Download />}
            tooltipTitle="Exporter"
            onClick={(e) => {
              setExportMenuAnchor(e.currentTarget);
              setSpeedDialOpen(false);
            }}
          />
        </SpeedDial>
      )}

      {/* Snackbars */}
      <Snackbar 
        open={!!error} 
        autoHideDuration={6000} 
        onClose={handleCloseError}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        TransitionComponent={Fade}
        sx={{ bottom: isMobile ? 70 : 16 }}
      >
        <Alert 
          onClose={handleCloseError} 
          severity="error" 
          sx={{ 
            width: '100%',
            borderRadius: 2,
            boxShadow: '0 4px 12px rgba(239,68,68,0.2)',
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          }}
        >
          {error}
        </Alert>
      </Snackbar>

      <Snackbar 
        open={!!success} 
        autoHideDuration={3000} 
        onClose={handleCloseSuccess}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        TransitionComponent={Zoom}
        sx={{ bottom: isMobile ? 70 : 16 }}
      >
        <Alert 
          onClose={handleCloseSuccess} 
          severity="success" 
          sx={{ 
            width: '100%',
            borderRadius: 2,
            boxShadow: '0 4px 12px rgba(16,185,129,0.2)',
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          }}
        >
          {success}
        </Alert>
      </Snackbar>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        TransitionComponent={Zoom}
        PaperProps={{
          sx: {
            borderRadius: 4,
            width: { xs: '90%', sm: 400 },
            textAlign: 'center',
            overflow: 'hidden',
            mx: 'auto'
          }
        }}
      >
        <Box sx={{
          background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
          p: { xs: 2, sm: 3 },
          textAlign: 'center'
        }}>
          <Avatar sx={{
            width: { xs: 50, sm: 70 },
            height: { xs: 50, sm: 70 },
            bgcolor: 'rgba(255,255,255,0.2)',
            margin: '0 auto 12px',
            border: '2px solid white'
          }}>
            <DeleteIcon sx={{ fontSize: { xs: 28, sm: 40 }, color: 'white' }} />
          </Avatar>
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, mb: 0.5, fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
            Confirmer la suppression
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
            Cette action est irréversible
          </Typography>
        </Box>

        <DialogContent sx={{ p: { xs: 2, sm: 4 }, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#1f2937' }}>
            Êtes-vous sûr de vouloir supprimer définitivement
          </Typography>
          <Chip
            label={partenaires.find(p => p.id === partenaireToDelete)?.name}
            sx={{
              bgcolor: '#fee2e2',
              color: '#dc2626',
              fontWeight: 600,
              fontSize: { xs: '0.875rem', sm: '1rem' },
              height: { xs: 32, sm: 36 },
              px: 2,
              border: '1px solid #fecaca',
              mb: 3
            }}
          />
          <Typography variant="caption" sx={{ color: '#6b7280', fontStyle: 'italic' }}>
            Cette action supprimera toutes les données associées
          </Typography>
        </DialogContent>

        <DialogActions sx={{ p: { xs: 2, sm: 3 }, pt: 0, justifyContent: 'center', gap: 2 }}>
          <Button
            onClick={() => setDeleteConfirmOpen(false)}
            variant="outlined"
            startIcon={<Cancel />}
            size={isMobile ? "small" : "medium"}
            sx={{
              borderRadius: 2,
              px: { xs: 2, sm: 3 },
              py: { xs: 0.75, sm: 1 },
              borderColor: '#d1d5db',
              color: '#6b7280'
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleDeletePartenaire}
            variant="contained"
            color="error"
            startIcon={<DeleteIcon />}
            size={isMobile ? "small" : "medium"}
            sx={{
              borderRadius: 2,
              px: { xs: 2, sm: 3 },
              py: { xs: 0.75, sm: 1 },
              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
            }}
          >
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add/Edit Partner Dialog - Responsive */}
      <Dialog 
        open={openDialog} 
        onClose={() => !submitting && setOpenDialog(false)} 
        fullWidth 
        maxWidth="sm"
        TransitionComponent={Zoom}
        PaperProps={{
          sx: {
            borderRadius: { xs: 3, sm: 4 },
            overflow: 'hidden',
            boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
            mx: { xs: 2, sm: 'auto' }
          }
        }}
      >
        {submitting && (
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255,255,255,0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1
          }}>
            <CircularProgress size={isMobile ? 40 : 60} thickness={4} />
          </Box>
        )}

        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: { xs: 2, sm: 3 },
          px: { xs: 2, sm: 4 },
          display: 'flex',
          alignItems: 'center',
          gap: 2
        }}>
          <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 } }}>
            {editingPartenaire ? <EditIcon /> : <AddIcon />}
          </Avatar>
          <Box>
            <Typography variant="h6" fontWeight={700} sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
              {editingPartenaire ? "Modifier le Partenaire" : "Nouveau Partenaire"}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.9 }}>
              {editingPartenaire ? "Mettez à jour les informations" : "Ajoutez un nouveau partenaire"}
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ py: { xs: 2, sm: 4 }, px: { xs: 2, sm: 4 } }}>
          <br></br>
          <br></br>
          <Grid container spacing={{ xs: 2, sm: 3 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nom du Partenaire"
                required
                variant="outlined"
                value={newPartenaire.name}
                onChange={(e) => setNewPartenaire({ ...newPartenaire, name: e.target.value.toUpperCase() })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Business sx={{ color: '#667eea', fontSize: { xs: 18, sm: 20 } }} />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: 2,
                    bgcolor: '#F9FAFB',
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="URL de l'Image"
                variant="outlined"
                value={newPartenaire.image}
                onChange={(e) => setNewPartenaire({ ...newPartenaire, image: e.target.value })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ImageIcon sx={{ color: '#667eea', fontSize: { xs: 18, sm: 20 } }} />
                    </InputAdornment>
                  ),
                  endAdornment: newPartenaire.image && (
                    <InputAdornment position="end">
                      <Avatar 
                        src={newPartenaire.image} 
                        sx={{ width: { xs: 28, sm: 32 }, height: { xs: 28, sm: 32 } }} 
                      />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: 2,
                    bgcolor: '#F9FAFB',
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Taux de Commission"
                type="number"
                required
                variant="outlined"
                value={newPartenaire.commission}
                onChange={(e) => setNewPartenaire({ ...newPartenaire, commission: e.target.value })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Percent sx={{ color: '#667eea', fontSize: { xs: 18, sm: 20 } }} />
                    </InputAdornment>
                  ),
                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                  inputProps: { min: 0, max: 100, step: 0.1 },
                  sx: {
                    borderRadius: 2,
                    bgcolor: '#F9FAFB',
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ 
          px: { xs: 2, sm: 4 }, 
          py: { xs: 2, sm: 3 }, 
          bgcolor: '#F9FAFB',
          justifyContent: 'space-between',
          flexDirection: { xs: 'column-reverse', sm: 'row' },
          gap: { xs: 1, sm: 0 }
        }}>
          <Button 
            onClick={() => setOpenDialog(false)} 
            variant="outlined"
            startIcon={<Cancel />}
            disabled={submitting}
            fullWidth={isMobile}
            sx={{
              borderRadius: 2,
              fontSize: { xs: '0.875rem', sm: '0.9375rem' }
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={editingPartenaire ? handleSaveEditPartenaire : handleAddPartenaire}
            variant="contained"
            color="primary"
            disabled={submitting}
            startIcon={submitting ? null : (editingPartenaire ? <Save /> : <AddIcon />)}
            fullWidth={isMobile}
            sx={{
              background: 'linear-gradient(45deg, #667eea, #764ba2)',
              '&:hover': {
                background: 'linear-gradient(45deg, #5a67d8, #6b46a1)',
                transform: 'translateY(-2px)'
              },
              fontSize: { xs: '0.875rem', sm: '0.9375rem' }
            }}
          >
            {submitting ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={20} sx={{ color: 'white' }} />
                {editingPartenaire ? "Enregistrement..." : "Création..."}
              </Box>
            ) : (
              editingPartenaire ? "Enregistrer" : "Créer"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Actions Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
          setCurrentPartnerId(null);
        }}
        TransitionComponent={Fade}
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            minWidth: 180,
            width: isMobile ? 'auto' : 'auto'
          }
        }}
      >
        <MenuItem onClick={() => {
          const partner = partenaires.find(p => p.id === currentPartnerId);
          setEditingPartenaire(partner);
          setNewPartenaire({
            name: partner.name,
            image: partner.image || '',
            commission: partner.commission
          });
          setOpenDialog(true);
          setAnchorEl(null);
        }}>
          <ListItemIcon>
            <EditIcon fontSize="small" sx={{ color: '#667eea' }} />
          </ListItemIcon>
          <Typography variant="body2">Modifier</Typography>
        </MenuItem>
        <MenuItem onClick={() => {
          handleDeleteConfirmation(currentPartnerId);
          setAnchorEl(null);
        }}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" sx={{ color: '#ef4444' }} />
          </ListItemIcon>
          <Typography variant="body2" sx={{ color: '#ef4444' }}>Supprimer</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default PartenairesPage;